<template>
    <button-icon :icon_name=icon_name class="btn--icon-rounded" v-bind="$attrs">
        <slot></slot>
    </button-icon>
</template>
<script>
import buttonIcon from './button_icon';
export default {
  components: {
    'button-icon': buttonIcon,
  },
  props: {
    icon_name: {
      type: String,
    },
  },
};
</script>
